module.exports = __webpack_public_path__ + "static/media/wrench.82640b7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/wrench.svg
// module id = 257
// module chunks = 0